/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_FeaturedInputs */



/**

* @param {_Wiki_FeaturedInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _wiki_featured = /** @type {((inputs?: _Wiki_FeaturedInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_FeaturedInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beliebte Artikel")
});